import { css } from '@emotion/react';

const makeSummaryContentStyling = () => {
  return {
    textWithIconContainer: css({
      display: 'flex',
      '& svg': {
        fontSize: 38,
        marginRight: 18,
      },
    }),
  };
};

export default makeSummaryContentStyling;
